import { QueueDisplayScreen, RegisterDisplayRequest } from '../../models/Entities/Turnero';
import { ErrorType } from '../../models/HttpError';

export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_ALL_FAILURE';

export interface TurneroQueueDisplayScreenGetAllRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_REQUEST;
}

export interface TurneroQueueDisplayScreenGetAllSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_SUCCESS;
    payload: QueueDisplayScreen[];
}

export interface TurneroQueueDisplayScreenGetAllFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_ALL_FAILURE;
    error: ErrorType;
}

export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_GET_BY_ID_FAILURE';

export interface TurneroQueueDisplayScreenGetByIdRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_REQUEST;
    id: number;
}

export interface TurneroQueueDisplayScreenGetByIdSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_SUCCESS;
    payload: QueueDisplayScreen;
}

export interface TurneroQueueDisplayScreenGetByIdFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_GET_BY_ID_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_CREATE_FAILURE';

export interface TurneroQueueDisplayScreenCreateRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_REQUEST;
    payload: QueueDisplayScreen;
}

export interface TurneroQueueDisplayScreenCreateSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_SUCCESS;
    payload: QueueDisplayScreen;
}

export interface TurneroQueueDisplayScreenCreateFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_CREATE_FAILURE;
    error: ErrorType;
}

export const TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_UPDATE_FAILURE';

export interface TurneroQueueDisplayScreenUpdateRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_REQUEST;
    id: number;
    payload: QueueDisplayScreen;
}

export interface TurneroQueueDisplayScreenUpdateSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_SUCCESS;
    id: number;
    payload: string;
}

export interface TurneroQueueDisplayScreenUpdateFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_DELETE_FAILURE';

export interface TurneroQueueDisplayScreenDeleteRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_REQUEST;
    id: number;
}

export interface TurneroQueueDisplayScreenDeleteSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_SUCCESS;
    payload: number;
}

export interface TurneroQueueDisplayScreenDeleteFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_REQUEST = 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_REQUEST';
export const TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_SUCCESS = 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_SUCCESS';
export const TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_FAILURE = 'TURNERO-QUEUE_DISPLAY_SCREEN_REGISTER_FAILURE';

export interface TurneroQueueDisplayScreenRegisterRequestAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_REQUEST;
    payload: RegisterDisplayRequest;
}

export interface TurneroQueueDisplayScreenRegisterSuccessAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_SUCCESS;
    payload: QueueDisplayScreen;
}

export interface TurneroQueueDisplayScreenRegisterFailureAction {
    type: typeof TURNERO_QUEUE_DISPLAY_SCREEN_REGISTER_FAILURE;
    error: ErrorType;
}
